export const serverUrl = {
    // baseURL: '/adminApi/',//测试环境
    baseURL: 'https://api.1668818.net/adminApi/',//正式环境
    uploadUrl: 'https://api.1668818.net/file/uploadObjectOSS',
    imgUrl: 'https://1668818-files.oss-cn-shanghai.aliyuncs.com/',
}



// WEBPACK FOOTER //
// ./src/utils/server.js